
export default {
  props: {
    containerStyle: {
      type: [String, Array],
      default: 'container-px',
    },
  },
}
